"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggableModalInner = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@blueprintjs/core");
var ResizeHandle_1 = require("./ResizeHandle");
var useDrag_1 = require("./useDrag");
var usePrevious_1 = require("./usePrevious");
var useResize_1 = require("./useResize");
var Card_1 = require("../../Card");
var dialog_1 = require("./dialog");
var Spinner_1 = require("../../Spinner");
require("./dialog.css");
var utils_1 = require("./utils");
var modalStyle = {
    margin: 0,
    paddingBottom: 0,
    pointerEvents: 'auto',
    position: 'relative'
};
exports.DraggableModalInner = (0, react_1.memo)(function (_a) {
    var id = _a.id, modalState = _a.modalState, dispatch = _a.dispatch, isOpen = _a.isOpen, children = _a.children, buttonsEndComponent = _a.buttonsEndComponent, disabled = _a.disabled, isSaving = _a.isSaving, onSave = _a.onSave, onCancel = _a.onCancel, saveText = _a.saveText, cancelText = _a.cancelText, enableDrag = _a.enableDrag, hideEndContainer = _a.hideEndContainer, top = _a.top, left = _a.left, modalProps = __rest(_a, ["id", "modalState", "dispatch", "isOpen", "children", "buttonsEndComponent", "disabled", "isSaving", "onSave", "onCancel", "saveText", "cancelText", "enableDrag", "hideEndContainer", "top", "left"]);
    (0, react_1.useEffect)(function () {
        var size = {
            height: (0, utils_1.getNumberMatch)(modalProps.height, 'height'),
            width: (0, utils_1.getNumberMatch)(modalProps.width, 'width')
        };
        dispatch({
            id: id,
            size: size,
            type: 'mount'
        });
        return function () { return dispatch({ id: id, type: 'unmount' }); };
    }, [dispatch, id]);
    (0, react_1.useEffect)(function () {
        var size = {
            height: (0, utils_1.getNumberMatch)(modalProps.height, 'height'),
            width: (0, utils_1.getNumberMatch)(modalProps.width, 'width')
        };
        dispatch({
            id: id,
            size: size,
            type: 'mount'
        });
    }, [modalProps.height, modalProps.width]);
    var visiblePrevious = (0, usePrevious_1.usePrevious)(isOpen);
    (0, react_1.useEffect)(function () {
        if (isOpen !== visiblePrevious) {
            if (isOpen) {
                dispatch({ id: id, type: 'show' });
            }
            else {
                dispatch({ id: id, type: 'hide' });
            }
        }
    }, [isOpen, visiblePrevious, id, dispatch]);
    var zIndex = modalState.zIndex, x = modalState.x, y = modalState.y, width = modalState.width, height = modalState.height;
    var style = (0, react_1.useMemo)(function () { return (__assign(__assign({}, modalStyle), { zIndex: zIndex, top: y, left: x, height: modalProps.hasOwnProperty('height')
            ? modalProps.height
            : modalState.height, width: modalProps.hasOwnProperty('width')
            ? modalProps.width
            : modalState.width })); }, [y, x, height, width, zIndex]);
    var onFocus = (0, react_1.useCallback)(function () { return dispatch({ id: id, type: 'focus' }); }, [
        id,
        dispatch
    ]);
    var onDragWithID = (0, react_1.useCallback)(function (args) { return dispatch(__assign({ id: id, type: 'drag' }, args)); }, [dispatch, id]);
    var onResizeWithID = (0, react_1.useCallback)(function (args) { return dispatch(__assign({ id: id, type: 'resize' }, args)); }, [dispatch, id]);
    var onMouseDrag = (0, useDrag_1.useDrag)(x, y, onDragWithID);
    var onMouseResize = (0, useResize_1.useResize)(x, y, width, height, onResizeWithID);
    return (react_1.default.createElement(dialog_1.DialogDS, { portalClassName: 'gsi-draggable-modal', style: style, canEscapeKeyClose: false, hasBackdrop: true, canOutsideClickClose: false, isOpen: isOpen, autoFocus: false, enforceFocus: false },
        react_1.default.createElement(Card_1.VCardPanel, __assign({}, modalProps, { headerClass: 'gsi-draggable-modal-title', height: modalProps.hasOwnProperty('height')
                ? modalProps.height
                : "".concat(modalState.height, "px"), width: modalProps.hasOwnProperty('width')
                ? modalProps.width
                : "".concat(modalState.width, "px"), onHeaderFocus: onFocus, onHeaderMouseDrag: onMouseDrag, bodyPadding: '0px' }),
            react_1.default.createElement(dialog_1.DialogBodyContainer, { buttonHeight: hideEndContainer ? '0px' : '45px' }, children),
            !hideEndContainer && (react_1.default.createElement(dialog_1.DialogButtonsEndsContainers, null, buttonsEndComponent ? (buttonsEndComponent) : isSaving ? (react_1.default.createElement(Spinner_1.VSpinner, { size: 24 })) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.AnchorButton, { minimal: true, icon: 'tick', disabled: disabled, text: saveText ? saveText : 'Save', onClick: onSave, intent: 'success' }),
                react_1.default.createElement(core_1.AnchorButton, { minimal: true, icon: 'disable', text: cancelText ? cancelText : 'Cancel', onClick: onCancel, intent: 'danger' })))))),
        enableDrag && react_1.default.createElement(ResizeHandle_1.ResizeHandle, { onMouseDown: onMouseResize })));
});
exports.DraggableModalInner.displayName = 'DraggableModalInner';
